import { useParams } from 'react-router-dom'

import { RoleLevelDetailsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import JobLevelEmployeesDataCollection from 'modules/project_management/components/tables/JobLevelEmployeesDataCollection'

const RoleDetailsPage = () => {
  const { data, loading, error } = useQuery(RoleLevelDetailsPageDocument)

  const canSeeJobsAndRatesPage = !!data?.projectManagement._policies.pagesSeeJobsAndRates.can

  return (
    <ResponsivePage.Body
      variant="wide"
      loading={!data && loading}
      error={error}
      authorized={canSeeJobsAndRatesPage}
    >
      <JobLevelEmployeesDataCollection />
    </ResponsivePage.Body>
  )
}

export default RoleDetailsPage
